<template>
  <div class="be-content" v-if="user">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading panel-heading-divider">Профиль пользователя
            </div>
            <div class="panel-body">
              <form class="form-horizontal">
                <div class="form-group">
                  <label class="col-sm-2 control-label">Имя пользователя(Логин):</label>
                  <label class="col-sm-10 control-label">
                    <span class="pull-left">{{user.username}}</span>
                  </label>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('user.name')}">
                  <label class="col-sm-2 control-label"><b>Ф.И.О и должность лица*:</b></label>
                  <div class="col-sm-10">
                    <input v-validate="'required|max:768'" class="form-control input-sm"
                           data-vv-as="Ф.И.О и должность лица"
                           :class="{'input': true, 'is-danger': errors.has('user.name')}"
                           name="user.name"
                           type="text" placeholder="Ф.И.О и должность лица" v-model="user.name" autocomplete="off">
                    <span v-show="errors.has('user.name')" class="text-danger">{{ errors.first('user.name') }}</span>
                  </div>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('user.phone')}">
                  <label class="col-sm-2 control-label"><b>Контактный номер телефона*:</b></label>
                  <div class="col-sm-10">
                    <input v-validate="'required|numeric'" class="form-control input-sm"
                           data-vv-as="Контактный номер телефона"
                           :class="{'input': true, 'is-danger': errors.has('user.phone') }" name="phone"
                           type="text" placeholder="Контактный номер телефона" v-model="user.phone" autocomplete="on">
                    <span v-show="errors.has('user.phone')" class="text-danger">{{ errors.first('user.phone') }}</span>
                  </div>
                </div>
              </form>
              <div class="row xs-pt-15">
                <div class="col-xs-12">
                  <p class="text-center">
                    <button class="btn btn-space btn-success btn-lg " @click="submitData">Сохранить изменения
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading panel-heading-divider">Смена пароля
            </div>
            <div class="panel-body">
              В целях безопасности, пожалуйста, введите свой старый пароль, затем введите новый пароль дважды, чтобы мы могли убедиться в правильности написания.
              <form class="form-horizontal">
                <div class="form-group" :class="{'has-error' : errors.has('old_password')}">
                  <label class="col-sm-2 control-label"><b>Старый пароль:</b></label>
                  <div class="col-sm-10">
                    <input v-validate="'required'" class="form-control input-sm"
                           data-vv-as="Старый пароль"
                           :class="{'input': true, 'is-danger': errors.has('old_password') }" name="old_password"
                           type="password" v-model="old_password" autocomplete="on">
                    <span v-show="errors.has('old_password')" class="text-danger">{{ errors.first('old_password')
                      }}</span>
                  </div>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('new_password1')}">
                  <label class="col-sm-2 control-label"><b>Новый пароль:</b></label>
                  <div class="col-sm-10">
                    <input v-validate="'required|min:8'" class="form-control input-sm"
                           data-vv-as="Новый пароль"
                           :class="{'input': true, 'is-danger': errors.has('new_password1') }" name="new_password1"
                           type="password" v-model="new_password1" autocomplete="on">
                    <span>
                      <li>Ваш пароль не должен совпадать с вашим именем или другой персональной информацией или быть слишком похожим на неё.</li>
                      <li>Ваш пароль должен содержать как минимум 8 символов.</li>
                      <li>Ваш пароль не может быть одним из широко распространённых паролей.</li>
                      <li>Ваш пароль не может состоять только из цифр.</li>
                    </span>
                    <span v-show="errors.has('new_password1')" class="text-danger">{{ errors.first('new_password1')
                      }}</span>
                  </div>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('new_password2')}">
                  <label class="col-sm-2 control-label"><b>Подтверждение нового пароля:</b></label>
                  <div class="col-sm-10">
                    <input v-validate="'required|confirmed:new_password1|min:8'" class="form-control input-sm"
                           data-vv-as="Подтверждение нового пароля"
                           :class="{'input': true, 'is-danger': errors.has('new_password2') }" name="new_password2"
                           type="password" v-model="new_password2" autocomplete="on">
                    <span v-show="errors.has('new_password2')" class="text-danger">{{ errors.first('new_password2')
                      }}</span>
                  </div>
                </div>
              </form>
              {{new_password1}}<br>
              {{new_password2}}
              <div class="row xs-pt-15">
                <div class="col-xs-12">
                  <p class="text-center">
                    <button class="btn btn-space btn-success btn-lg " @click="changePassword">Изменить пароль
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapActions} from 'vuex'

  export default {
    props: {
      id: {
        required: true
      }
    },
    data: function () {
      return {
        user: null,
        old_password: null,
        new_password1: null,
        new_password2: null
      }
    },
    created () {
      axios.get('/api/users/' + this.id + '/')
        .then(response => {
          this.user = response.data
        })
    },
    methods: {
      changePassword () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post('/api/rest-auth/password/change/', {
              'old_password': this.old_password,
              'new_password1': this.new_password1,
              'new_password2': this.new_password2
            }).then(
              (response) => {
                if (response.status === 200) {
                  this.$snotify.success('Пароль изменен.', 'Успешно!')
                }
              },
              (error) => {
                if (error.response.status === 400) {
                  for (let [key, value] of Object.entries(error.response.data)) {
                    this.errors.add(key, value[0], 'server')
                  }
                  this.errors.add(error.response.data)
                } else if (error.response.status >= 400) {
                  this.errorMessages = ['Ошибка!. Попробуйте позже.']
                }
              }
            )
          } else {
            this.errorMessages = ['Проверьте введенные данные!']
          }
        })
      },
      submitData: function () {
        axios.patch('/api/users/' + this.id + '/', this.user)
          .then((response) => {
            if (response.status === 200) {
              this.$snotify.success('Изменения сохранены.', 'Успешно!')
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('Ошибка сохранения данных!')
            }
          })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/user/Profile.vue